import { createFileRoute } from '@tanstack/react-router'
import { StaffEkonomi } from '../../../../components/StaffEkonomi'

export const Route = createFileRoute('/platform/desa/$desaId/ekonomi')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffEkonomi desaId={desaId} />
  },
})
